import { useInkind } from '@gik/api/inkinds/inkind';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { H1Bone } from '@gik/ui/SkeletonLoader/Bones/H1Bone';
import he from 'he';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface IWishlistPageHeaderProps {
  inkindRouteId: string;
}

const Skeleton = () => <H1Bone center />;

function WishlistPageHeaderComp({ inkindRouteId }: IWishlistPageHeaderProps) {
  const { t } = useTranslation();
  const { data: inkindPage, error: inkindPageError } = useInkind(inkindRouteId);

  const isLoading = !inkindPage;
  const isError = isLoading && inkindPageError;

  if (isLoading) return <Skeleton />;
  if (isError) return <Skeleton />;

  return (
    <h1>
      {t(translationKeys.title, {
        inkindPageTitle: he.decode(inkindPage?.title),
      })}
    </h1>
  );
}

export const WishlistPageHeader = withComponentErrorBoundary(WishlistPageHeaderComp);
